import React, { useEffect } from "react";
import Layout from "../layouts/Layout";
import styles from "../styles/_pages/regulations.module.scss";

const Privacy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Layout>
      <div className={styles.container}>
        <div className={styles.wrapper}>
          <h1>מדיניות פרטיות</h1>

          <h2>מבוא ומחויבות</h2>

          <p>
            ברוכים הבאים לאתר של גט פארט בע"מ. אנו ב-גט פארט מכבדים את פרטיותכם
            ומחויבים להגן על המידע האישי שאתם משתפים עמנו. מדיניות פרטיות זו
            מפרטת כיצד אנו אוספים, משתמשים, חושפים ומגנים על המידע שלכם, וכיצד
            אנו פועלים בהתאם לחוק הגנת הפרטיות התשמ"א-1981, לרבות תיקון מס' 13,
            ולכל דין רלוונטי.
          </p>

          <p>
            מדיניות זו חלה על איסוף מידע באתר זה ועל ידי כל אמצעי תקשורת אחר של
            גט פארט. אנא קראו אותה בעיון.
          </p>

          <br />

          <h2>1. סוגי המידע שאנו אוספים</h2>

          <p>אנו אוספים מידע אישי בשתי דרכים עיקריות:</p>

          <p className={styles.underline}>
            א. מידע שאתם מוסרים לנו באופן יזום:
          </p>
          <p>
            מידע זה כולל פרטים שאתם ממלאים בטפסים, שליחת קורות חיים, או יצירת
            קשר ישירה עמנו. לדוגמה:
          </p>
          <p>● פרטי יצירת קשר: שם מלא, מספר טלפון, כתובת דוא"ל, כתובת פיזית.</p>
          <p>● תוכן הפנייה: תיאור פרויקטים, שאלות, בקשות, הערות.</p>
          <p>
            ● פניות למשרות וגיוס: קובץ קורות חיים, מכתבים נלווים, מספר תעודת
            זהות (רק במידת הצורך).
          </p>

          <p className={styles.underline}>ב. מידע שנאסף באופן אוטומטי:</p>
          <p>
            במהלך שימושכם באתר, אנו עשויים לאסוף מידע טכני וסטטיסטי באופן
            אוטומטי. מידע זה אינו מזהה אתכם באופן אישי (אלא אם הוא משולב עם מידע
            שמסרתם לנו) וכולל:
          </p>
          <p>
            ● פרטי שימוש: כתובת IP, סוג דפדפן ומערכת הפעלה, עמודים שבהם ביקרתם,
            זמני גישה, ופעילות באתר.
          </p>
          <p>● נתוני מיקום: מידע גאוגרפי כללי (למשל, מדינה).</p>

          <br />

          <h2>2. מטרות השימוש במידע</h2>

          <p>אנו משתמשים במידע שלכם אך ורק למטרות הבאות:</p>
          <p>
            ● מתן שירות ויצירת קשר: כדי לספק לכם הצעות מחיר, לענות על פניותיכם,
            לספק תמיכה טכנית ולספק את השירותים שביקשתם.
          </p>
          <p>
            ● גיוס והעסקה: כדי לבחון מועמדות למשרות, לנהל את תהליך הגיוס וליצור
            קשר עם מועמדים.
          </p>
          <p>
            ● שיפור ופיתוח: כדי לנתח את השימוש באתר ולשפר את השירותים, התוכן
            והחוויה הכללית.
          </p>
          <p>
            ● תקשורת שיווקית (בכפוף להסכמה): כדי לשלוח לכם מידע על שירותים
            חדשים, מבצעים, עדכונים ואירועים (רק אם נתתם לכך הסכמה מפורשת).
          </p>

          <br />

          <h2>3. בסיס חוקי לעיבוד המידע</h2>

          <p>עיבוד המידע האישי שלכם נעשה בהתאם לבסיסים החוקיים הבאים:</p>
          <p>
            ● הסכמתכם: כאשר נתתם הסכמה מפורשת ומרצון לעיבוד המידע שלכם למטרה
            מסוימת (למשל, לשליחת חומרים שיווקיים).
          </p>
          <p>
            ● קיום חוזה: כאשר עיבוד המידע נחוץ לצורך ביצוע חוזה או מתן שירות
            שביקשתם (למשל, כדי ליצור עמכם קשר בנוגע לפרויקט).
          </p>
          <p>
            ● אינטרס לגיטימי: כאשר עיבוד המידע נחוץ לצורך אינטרס לגיטימי של גט
            פארט, כגון אבטחת מידע, שיפור השירותים שלנו או ניתוח סטטיסטי, בכפוף
            לאיזון עם זכויותיכם.
          </p>
          <p>
            ● חובה חוקית: כאשר עיבוד המידע נדרש על פי חוק (למשל, לצורך דיווח
            לרשויות).
          </p>

          <br />

          <h2>4. זכות לשלוט במידע (זכויות נשואי המידע)</h2>

          <p>
            אתם רשאים לממש את זכויותיכם בכל עת. אנו מחויבים להיענות לבקשותיכם
            בהתאם לחוק. זכויותיכם כוללות:
          </p>
          <p>
            ● זכות העיון והגישה: אתם רשאים לבקש לקבל עותק של המידע האישי שאנו
            מחזיקים עליכם.
          </p>
          <p>● זכות התיקון: באפשרותכם לבקש לתקן מידע שגוי או לא עדכני.</p>
          <p>
            ● זכות המחיקה: אתם רשאים לבקש למחוק את המידע האישי שלכם, בכפוף
            למגבלות החוק.
          </p>
          <p>
            ● זכות ההתנגדות: אתם רשאים להתנגד לעיבוד המידע שלכם למטרות מסוימות,
            ובמיוחד למטרות שיווקיות.
          </p>
          <p>
            ● משיכת הסכמה: באפשרותכם למשוך את הסכמתכם לעיבוד מידע בכל עת, מבלי
            להשפיע על חוקיות העיבוד שבוצע לפני משיכת ההסכמה.
          </p>

          <br />

          <h2>5. שיתוף מידע עם צדדים שלישיים</h2>

          <p>
            אנו לא מוכרים, משכירים או מעבירים את המידע האישי שלכם לצדדים שלישיים
            למטרות שיווקיות. עם זאת, אנו עשויים לשתף את המידע שלכם רק כאשר זה
            נדרש לצורך מתן השירות שביקשתם או על פי חובה חוקית:
          </p>
          <p>
            ● ספקי שירותים: נשתף מידע עם ספקים חיצוניים המעניקים לנו שירותים
            תומכים (כגון: אחסון ענן, ניתוח נתונים, שירותי דיוור, ספקי התקנה,
            אוטומציה שיווקית). ספקים אלה מחויבים בהסכם לשמור על סודיות המידע.
          </p>
          <p>
            ● גופים משפטיים ורשויות: נחשוף מידע רק במקרים הנדרשים על פי דין, צו
            בית משפט או לצורך אכיפת זכויותינו.
          </p>
          <p>
            ● תהליכי גיוס: לצורך בחינת התאמה לתפקיד, נשתף מידע עם חברות בדיקת
            רקע (אם רלוונטי) ובתיאום אתכם.
          </p>

          <br />

          <h2>6. עוגיות (Cookies)</h2>

          <p>
            האתר שלנו עושה שימוש בקבצי "עוגיות" (Cookies) וטכנולוגיות דומות כדי
            לשפר את חווית המשתמש, לנתח את פעילות האתר ולהתאים את התוכן והמודעות
            לצרכים שלכם. באפשרותכם לשלוט בהגדרות העוגיות דרך הדפדפן שלכם או
            באמצעות כלי הנגישות המובנה באתר.
          </p>

          <br />

          <h2>7. אבטחת מידע</h2>

          <p>
            אנו נוקטים באמצעי אבטחה טכניים וארגוניים מחמירים כדי להגן על המידע
            האישי שלכם מפני גישה בלתי מורשית, שימוש לרעה, אובדן או חשיפה. אמצעים
            אלה כוללים:
          </p>
          <p>● הצפנת נתונים רגישים.</p>
          <p>● הגבלת גישה למידע לעובדים המורשים בלבד.</p>
          <p>● שימוש בשרתים מאובטחים.</p>
          <p>● מעקב ובקרה על פעילות במערכות המידע.</p>

          <p>
            דיווח על אירוע אבטחה: במקרה של חשד לפריצה או אירוע אבטחה, אנו נפעל
            בהתאם להנחיות החוק, לרבות דיווח לרשות להגנת הפרטיות.
          </p>

          <br />

          <h2>8. שמירת המידע</h2>

          <p>
            אנו נשמור את המידע האישי שלכם כל עוד יש לכך מטרה לגיטימית. לאחר מכן,
            המידע יימחק בצורה מאובטחת.
          </p>
          <p>● פניות שירות ולקוחות: עד 7 שנים.</p>
          <p>
            ● מועמדים לעבודה: עד 2 שנים לאחר סיום הליך הגיוס (אלא אם ביקשתם
            מחיקה מוקדמת).
          </p>
          <p>● רשומות חוקיות: נתוני חשבונאות יישמרו בהתאם לחוק (עד 7 שנים).</p>

          <br />

          <h2>9. יצירת קשר</h2>

          <p>
            לכל שאלה, בקשה בנוגע לזכויותיכם או תלונה בנושא פרטיות, אתם מוזמנים
            ליצור עמנו קשר בפרטים הבאים:
          </p>

          <p className={styles.underline}>ממונה הגנת הפרטיות:</p>
          <p>שם: מאיר</p>
          <p>טלפון: 052-8098805</p>
          <p>דוא"ל: getpart4@gmail.com</p>

          <p className={styles.underline}>פניות כלליות לחברה:</p>
          <p>טלפון: 09-7467557</p>
          <p>דוא"ל: getpart4@gmail.com</p>
          <p>כתובת: אזור תעשייה מעיין צבי, מספר 6</p>

          <p>
            זמני מענה: אנו נשתדל לספק מענה ראשוני בתוך 48 שעות ולטפל בפנייתכם
            המלאה בתוך 30 יום.
          </p>

          <br />

          <h2>10. שינויים במדיניות הפרטיות</h2>

          <p>
            אנו שומרים לעצמנו את הזכות לעדכן מדיניות פרטיות זו מעת לעת. במקרה של
            שינויים מהותיים, נודיע לכם באמצעים סבירים. המשך השימוש שלכם באתר
            לאחר פרסום השינויים מהווה הסכמה למדיניות המעודכנת.
          </p>

          <br />

          <h2>11. תחולה ותוקף</h2>

          <p>
            מדיניות זו תקפה מיום 1.10.2025 ותחול על כל המידע שנאסף לאחר תאריך
            זה.
          </p>
        </div>
      </div>
    </Layout>
  );
};

export default Privacy;
